import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { appConfig } from '../app.config';
import { Observable } from 'rxjs';
import { accessPoint, accessPointAddress, accessPointAddresses, accessPointAttachment, accessPointAttachmentAttribute, accessPointAttachmentAttributes, accessPointAttachments, accessPointIdentifier, accessPointIdentifiers, accessPoints, identifierType, identifierTypes, legalEntities, legalEntity, realEstateAssetAssignment, realEstateAssetAssignments, realEstateAssetIdentifier, realEstateAssetIdentifiers, site, siteCertification, siteCertifications, sites, sourceSystem, sourceSystems } from './models/SitesModel';

@Injectable({
  providedIn: 'root'
})
export class SitesService {
  config:any
  apiUrl: string='';
  constructor(private apiService: CommonService) {
    this.config=appConfig
    this.apiUrl=appConfig.SitesServiceUrl//this.config.SitesServiceUrl;
  }
  getAccessPointIdentifiers(url):Observable<accessPointIdentifiers> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-point-identifiers`, url) as Observable<accessPointIdentifiers>;
    return this.apiService.response(data,accessPointIdentifiers,'access-point-identifiers') as Observable<accessPointIdentifiers>;
  }
  getAccessPointIdentifierbyId(url):Observable<accessPointIdentifier> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-point-identifiers`, url) as Observable<accessPointIdentifier>;
    return this.apiService.response(data,accessPointIdentifier,'access-point-identifiers') as Observable<accessPointIdentifier>;
  }
  createAccessPointIdentifier(url,data):Observable<accessPointIdentifier> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-access-point-identifiers`, url,data) as Observable<accessPointIdentifier>;
  }
  updateAccessPointIdentifier(url,data):Observable<accessPointIdentifier> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-access-point-identifiers`, url,data) as Observable<accessPointIdentifier>;
  }
  deleteAccessPointIdentifier(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-access-point-identifiers`, url) as Observable<any>;
  }
  getRealEstateAssetIdentifiers(url):Observable<realEstateAssetIdentifiers> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-real-estate-asset-identifiers`, url) as Observable<realEstateAssetIdentifiers>;
    return this.apiService.response(data,realEstateAssetIdentifiers,'real-estate-asset-identifiers') as Observable<realEstateAssetIdentifiers>;
  }
  getRealEstateAssetIdentifierbyId(url):Observable<realEstateAssetIdentifier> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-real-estate-asset-identifiers`, url) as Observable<realEstateAssetIdentifier>;
    return this.apiService.response(data,realEstateAssetIdentifier,'real-estate-asset-identifiers') as Observable<realEstateAssetIdentifier>;
  }
  createRealEstateAssetIdentifier(url,data):Observable<realEstateAssetIdentifier> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-real-estate-asset-identifiers`, url,data) as Observable<realEstateAssetIdentifier>;
  }
  updateRealEstateAssetIdentifier(url,data):Observable<realEstateAssetIdentifier> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-real-estate-asset-identifiers`, url,data) as Observable<realEstateAssetIdentifier>;
  }
  deleteRealEstateAssetIdentifier(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-real-estate-asset-identifiers`, url) as Observable<any>;
  }
  getAccessPoints(url):Observable<accessPoints> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-points`, url) as Observable<accessPoints>;
    return this.apiService.response(data,accessPoints,'access-points') as Observable<accessPoints>;
  }
  getAccessPointbyId(url):Observable<accessPoint> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-points`, url) as Observable<accessPoint>;
    return this.apiService.response(data,accessPoint,'access-points') as Observable<accessPoint>;
  }
  createAccessPoint(url,data):Observable<accessPoint> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-access-points`, url,data) as Observable<accessPoint>;
  }
  updateAccessPoint(url,data):Observable<accessPoint> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-access-points`, url,data) as Observable<accessPoint>;
  }
  deleteAccessPoint(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-access-points`, url) as Observable<any>;
  }
  getSites(url):Observable<sites> {
   //url=url.replace(this.config.ApiSitesUrl,"https://qa.apis.renault.fr/")
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-sites`, url) as Observable<sites>;
    return this.apiService.response(data,sites,'sites') as Observable<sites>;
  }
  getSitebyId(url):Observable<site> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-sites`, url) as Observable<site>;
    return this.apiService.response(data,site,'sites') as Observable<site>;
  }
  createSite(url,data):Observable<site> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-sites`, url,data) as Observable<site>;
  }
  updateSite(url,data):Observable<site> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-sites`, url,data) as Observable<site>;
  }
  getAccessPointAddresses(url):Observable<accessPointAddresses> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-points-addresses`, url) as Observable<accessPointAddresses>;
    return this.apiService.response(data,accessPointAddresses,'access-points-addresses') as Observable<accessPointAddresses>;
  }
  getAccessPointAddressbyId(url):Observable<accessPointAddress> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-points-addresses`, url) as Observable<accessPointAddress>;
    return this.apiService.response(data,accessPointAddress,'access-points-addresses') as Observable<accessPointAddress>;
  }
  createAccessPointAddress(url,data):Observable<accessPointAddress> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-access-points-addresses`, url,data) as Observable<accessPointAddress>;
  }
  deleteAccessPointAddress(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-access-points-addresses`, url) as Observable<any>;
  }
  getRealEstateAssetAssignments(url):Observable<realEstateAssetAssignments> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-real-estate-asset-assignments`, url) as Observable<realEstateAssetAssignments>;
    return this.apiService.response(data,realEstateAssetAssignments,'real-estate-asset-assignments') as Observable<realEstateAssetAssignments>;
  }
  getRealEstateAssetAssignmentbyId(url):Observable<realEstateAssetAssignment> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-real-estate-asset-assignments`, url) as Observable<realEstateAssetAssignment>;
    return this.apiService.response(data,realEstateAssetAssignment,'real-estate-asset-assignments') as Observable<realEstateAssetAssignment>;
  }
  createRealEstateAssetAssignment(url,data):Observable<realEstateAssetAssignment> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-real-estate-asset-assignments`, url,data) as Observable<realEstateAssetAssignment>;
  }
  updateRealEstateAssetAssignment(url,data):Observable<realEstateAssetAssignment> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-real-estate-asset-assignments`, url,data) as Observable<realEstateAssetAssignment>;
  }
  getIdentifierTypes(url):Observable<identifierTypes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-identifier-types`, url) as Observable<identifierTypes>;
    return this.apiService.response(data,identifierTypes,'identifier-types') as Observable<identifierTypes>;
  }
  getIdentifierTypebyId(url):Observable<identifierType> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-identifier-types`, url) as Observable<identifierType>;
    return this.apiService.response(data,identifierType,'identifier-types') as Observable<identifierType>;
  }
  getAccessPointAttachments(url):Observable<accessPointAttachments> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-point-attachments`, url) as Observable<accessPointAttachments>;
    return this.apiService.response(data,accessPointAttachments,'access-point-attachments') as Observable<accessPointAttachments>;
  }
  getAccessPointAttachmentbyId(url):Observable<accessPointAttachment> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-point-attachments`, url) as Observable<accessPointAttachment>;
    return this.apiService.response(data,accessPointAttachment,'access-point-attachments') as Observable<accessPointAttachment>;
  }
  createAccessPointAttachment(url,data):Observable<accessPointAttachment> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-access-point-attachments`, url,data) as Observable<accessPointAttachment>;
  }
  updateAccessPointAttachment(url,data):Observable<accessPointAttachment> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-access-point-attachments`, url,data) as Observable<accessPointAttachment>;
  }
  getAccessPointAttachmentAttributes(url):Observable<accessPointAttachmentAttributes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-point-attachment-attributes`, url) as Observable<accessPointAttachmentAttributes>;
    return this.apiService.response(data,accessPointAttachmentAttributes,'access-point-attachment-attributes') as Observable<accessPointAttachmentAttributes>;
  }
  getAccessPointAttachmentAttributesbyId(url):Observable<accessPointAttachmentAttribute> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-access-point-attachment-attributes`, url) as Observable<accessPointAttachmentAttribute>;
    return this.apiService.response(data,accessPointAttachmentAttribute,'access-point-attachment-attributes') as Observable<accessPointAttachmentAttribute>;
  }
  createAccessPointAttachmentAttributes(url,data):Observable<accessPointAttachmentAttribute> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-access-point-attachment-attributes`, url,data) as Observable<accessPointAttachmentAttribute>;
  }
  createLegalEntity(url,data):Observable<legalEntity> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-legal-entities`, url,data) as Observable<legalEntity>;
  }
  updateLegalEntity(url,data):Observable<legalEntity> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-legal-entities`, url,data) as Observable<legalEntity>;
  }
  getSourceSystems(url):Observable<sourceSystems> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-source-systems`, url) as Observable<sourceSystems>;
    return this.apiService.response(data,sourceSystems,'source-systems') as Observable<sourceSystems>;
  }
  getSourceSystembyId(url):Observable<sourceSystem> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-source-systems`, url) as Observable<sourceSystem>;
    return this.apiService.response(data,sourceSystem,'source-systems') as Observable<sourceSystem>;
  }
  getSiteCertifications(url):Observable<siteCertifications> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-sites-certifications`, url) as Observable<siteCertifications>;
    return this.apiService.response(data,siteCertifications,'sites-certifications') as Observable<siteCertifications>;
  }
  getSiteCertificationbyId(url):Observable<siteCertification> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-sites-certifications`, url) as Observable<siteCertification>;
    return this.apiService.response(data,siteCertification,'sites-certifications') as Observable<siteCertification>;
  }
  createSitescertification(url,data):Observable<siteCertification> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-sites-certifications`, url,data) as Observable<siteCertification>;
  }
}
